import React from 'react';

/**
 * Checks if an error is related to missing LexOffice API key
 * Handles both Error instances and ApiError objects from the API
 */
export const isMissingLexOfficeApiKeyError = (error: unknown): boolean => {
  // Handle Error instances
  if (error instanceof Error) {
    return error.message.includes('Lex Office API key not configured for user');
  }

  // Handle ApiError objects with message property
  if (error && typeof error === 'object' && 'message' in error) {
    const errorMessage = String((error as { message: unknown }).message);
    return errorMessage.includes('Lex Office API key not configured for user');
  }

  // Handle string errors
  if (typeof error === 'string') {
    return error.includes('Lex Office API key not configured for user');
  }

  return false;
};

export const createLexOfficeApiKeyErrorContent = () =>
  React.createElement(
    'div',
    null,
    React.createElement(
      'p',
      { className: 'mb-2' },
      'Please configure your LexOffice API key to import bookings.'
    ),
    React.createElement(
      'a',
      {
        href: 'https://acconto-public-assets-dev.s3.eu-central-1.amazonaws.com/So+erstellst+du+einen+API.pdf',
        target: '_blank',
        rel: 'noopener noreferrer',
        className:
          'text-blue-600 dark:text-blue-400 underline hover:text-blue-800 dark:hover:text-blue-300',
      },
      'Learn how to create an API key →'
    )
  );
